"use client";

import { useState, useEffect } from "react";

type SortBy = "name" | "date" | "size";
type SortDirection = "asc" | "desc";

const SORT_BY_KEY = "afs-media-sort-by";
const SORT_DIRECTION_KEY = "afs-media-sort-direction";

export function useMediaSortPreferences(
  defaultSortBy: SortBy = "date",
  defaultSortDirection: SortDirection = "desc"
) {
  const [sortBy, setSortByState] = useState<SortBy>(defaultSortBy);
  const [sortDirection, setSortDirectionState] =
    useState<SortDirection>(defaultSortDirection);

  // Load saved preferences from localStorage on mount
  useEffect(() => {
    try {
      const savedSortBy = localStorage.getItem(SORT_BY_KEY);
      const savedSortDirection = localStorage.getItem(SORT_DIRECTION_KEY);

      if (
        savedSortBy &&
        (savedSortBy === "name" ||
          savedSortBy === "date" ||
          savedSortBy === "size")
      ) {
        setSortByState(savedSortBy as SortBy);
      }

      if (
        savedSortDirection &&
        (savedSortDirection === "asc" || savedSortDirection === "desc")
      ) {
        setSortDirectionState(savedSortDirection as SortDirection);
      }
    } catch (error) {
      console.warn(
        "Failed to load media sort preferences from localStorage:",
        error
      );
    }
  }, []);

  // Function to update sortBy and save to localStorage
  const setSortBy = (sortBy: SortBy) => {
    try {
      setSortByState(sortBy);
      localStorage.setItem(SORT_BY_KEY, sortBy);
    } catch (error) {
      console.warn("Failed to save media sortBy to localStorage:", error);
      setSortByState(sortBy);
    }
  };

  // Function to update sortDirection and save to localStorage
  const setSortDirection = (direction: SortDirection) => {
    try {
      setSortDirectionState(direction);
      localStorage.setItem(SORT_DIRECTION_KEY, direction);
    } catch (error) {
      console.warn(
        "Failed to save media sortDirection to localStorage:",
        error
      );
      setSortDirectionState(direction);
    }
  };

  return {
    sortBy,
    sortDirection,
    setSortBy,
    setSortDirection,
  };
}
